import React from "react";
import { Checkbox, ConfigProvider } from "antd";
import { Colors } from "../../config";

import "./styles.css";

const VerticalCheckbox = (props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBorder: Colors.main,
          colorPrimary: Colors.main,
        },
      }}
    >
      <Checkbox.Group
        {...props}
        className="flex flex-col gap-3 verticalCheckbox"
      />
    </ConfigProvider>
  );
};

export default VerticalCheckbox;
